import { render } from "./NavbarSection.vue?vue&type=template&id=54e2ff89"
import script from "./NavbarSection.vue?vue&type=script&lang=js"
export * from "./NavbarSection.vue?vue&type=script&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=54e2ff89&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__